import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronGrabberHorizontal"><Path d="M15 16L19 12L15 8" stroke="currentColor" strokeLinecap="square"/><Path d="M9 16L5 12L9 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontal;
